/**
 * App BACK「去修改」URL 上的 role / backType。
 * - Activity_admin_1 / 2：运营回退 → 既有 editRefused 纠错流
 * - Activity_admin_11 / 22：财务回退 → 跳转入金首页 TransferIntro
 * - backType=fundBack：入金回退 → 与财务 role 同路（即使 role 仍是运营节点）
 *
 * 判定顺序：先 fundBack，再匹配 11/22（避免 admin_1 前缀误伤 admin_11）。
 */

export const FINANCE_TRANSFER_ROLES = ['Activity_admin_11', 'Activity_admin_22'] as const;

/** role / backType 是否走财务回退（入金） */
export function isFinanceTransferEditRole(role?: string | null, backType?: string | null): boolean {
  if (String(backType ?? '').trim() === 'fundBack') return true;
  const r = String(role ?? '');
  if (!r) return false;
  return FINANCE_TRANSFER_ROLES.some((key) => r === key || r.includes(key));
}

/** 入金首页 TransferIntro 步号（与 OnlineProgress CompMaps 对齐） */
export function getTransferIntroStep(isMainland: boolean): number {
  return isMainland ? 17 : 16;
}
